import { useCallback, useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Tabs, Tab } from 'foundations-components/transitional/components/Tabs';
import EmbedCodeContainer from 'asset-actions-lib-forms/share/components/EmbedCodeContainer';
import ShareLink from 'asset-actions-lib-forms/share/components/ShareLink';
import HubspotTab from 'asset-actions-lib-forms/share/components/HubSpotTab';
import { DeveloperCode } from 'FormsCommonComponents/DeveloperCode';
import { ShareTabIds } from 'asset-actions-lib-forms/types';
import { LockedIcon } from 'foundations-assets/icons/components/LockedIcon';
import EmbedVersions from 'forms-utils-lib/constants/formDefinition/EmbedVersions';
import { RegularFormTypes } from 'asset-actions-lib-forms/constants/form';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function ShareTabbedViewWithHubspot({
  createdAt,
  embedType,
  formGuid,
  formName,
  embedVersion,
  hasRawHtmlAccess,
  onClickCMSRoute,
  onClickCTARoute,
  onClickPreviewShareLink,
  onClose,
  onCopyEmbedCode,
  onCopyShareLink,
  onCopyDeveloperCode,
  openUpgradeModalForDeveloperCode
}) {
  const isV4Form = embedVersion === EmbedVersions.V4;
  const defaultSelected = embedType === RegularFormTypes.SHAREABLE ? ShareTabIds.SHARE_LINK_TAB : ShareTabIds.EMBED_CODE_TAB;
  const [selected, setSelected] = useState(defaultSelected);
  const onSelectedChange = useCallback(event => {
    const value = event.target.value;
    if (value === ShareTabIds.DEVELOPER_CODE_TAB && !hasRawHtmlAccess) {
      return;
    }
    setSelected(value);
  }, [hasRawHtmlAccess]);
  return /*#__PURE__*/_jsxs(Tabs, {
    selected: selected,
    "data-test-id": "share-tabbed-view-with-hubspot",
    onSelectedChange: onSelectedChange,
    children: [/*#__PURE__*/_jsx(Tab, {
      "data-test-id": "embedCodeTab",
      tabId: ShareTabIds.EMBED_CODE_TAB,
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "assetActionsLibForms.modals.shareDialog.embedCode.title"
      }),
      children: /*#__PURE__*/_jsx(EmbedCodeContainer, {
        formGuid: formGuid,
        formName: formName,
        onClose: onClose,
        onCopy: onCopyEmbedCode,
        embedVersion: embedVersion
      })
    }), isV4Form && /*#__PURE__*/_jsx(Tab, Object.assign({
      "data-test-id": "developer-code-tab",
      tabId: ShareTabIds.DEVELOPER_CODE_TAB,
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "developerCode.title"
      })
    }, !hasRawHtmlAccess && {
      onClick: openUpgradeModalForDeveloperCode,
      icon: LockedIcon
    }, {
      children: /*#__PURE__*/_jsx(DeveloperCode, {
        formGuid: formGuid,
        onClick: onCopyDeveloperCode
      })
    })), /*#__PURE__*/_jsx(Tab, {
      "data-test-id": "shareLinkTab",
      tabId: ShareTabIds.SHARE_LINK_TAB,
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "assetActionsLibForms.modals.shareDialog.shareLink.title"
      }),
      children: /*#__PURE__*/_jsx(ShareLink, {
        createdAt: createdAt,
        formGuid: formGuid,
        embedVersion: embedVersion,
        onCopyShareLink: onCopyShareLink,
        onClickPreviewLink: onClickPreviewShareLink
      })
    }), /*#__PURE__*/_jsx(Tab, {
      "data-test-id": "hubspotTab",
      tabId: ShareTabIds.HUBSPOT_TAB,
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "assetActionsLibForms.modals.shareDialog.hubspotTab.title"
      }),
      children: /*#__PURE__*/_jsx(HubspotTab, {
        onClickCTARoute: onClickCTARoute,
        onClickCMSRoute: onClickCMSRoute
      })
    })]
  });
}